import React from 'react';

const CheckboxInput = ({name, value, error, label, onChange, columns}) => {
    const className = `col-12${columns?.md ? ' col-md-' + columns.md + '' : ''}`;
    return (
        <div className={className}>
            <div className="form-check py-2">
                <input type="checkbox"
                       className="form-check-input me-3"
                       name={name}
                       checked={value}
                       onChange={onChange}
                       id={name} />
                <label className="form-check-label fw-medium fs-sm opacity-75"
                       htmlFor={name}>
                    {label}
                </label>
            </div>
            {error && <div className="form-text text-start text-danger">{error}</div>}
        </div>
    )
};

export default CheckboxInput;
